import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core'
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms'
import { ICON_TYPE } from '@spartacus/storefront'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { OrderTrackingService } from '../order-tracking.service'
import { saveAs } from 'file-saver'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable, of } from 'rxjs'
import { DatePipe } from '@angular/common'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { StatusType } from '../../../models/status/status.model'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
import { CommonService } from '../../../shared/services/common.service'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../shared/services/user-role.service'
import {
  OrderStatusIndex,
  OrderStatusTypes,
  SAP_ORDER_STATUS,
} from '../../../models/status/order-status.model'

//import { ORDER_TRACKING_RESPONSE } from './order-details.model';

@Component({
  standalone: false,
  selector: 'vs-order-tracking-detail',
  templateUrl: './order-tracking-detail.component.html',
  styleUrls: ['./order-tracking-detail.component.scss'],
})
export class OrderTrackingDetailComponent implements OnInit {
  public infoMsg = false
  myprofile: FormGroup
  myprofiledetails: FormGroup
  myprofilenotify: FormGroup
  personaldetail: FormGroup
  iconTypes = ICON_TYPE
  expandAll = true
  fullResponse: any
  orderTrackingResponse: any
  orderStatus = StatusType.ORDER
  // currentOrderStatusId = OrderStatusIndex.SUBMITTED;
  orderIdToBeTracked: any
  orderInquiries: any
  inquiryForm: FormGroup
  inquiryFormSubmitted: boolean = false
  displayFormHideMessage: boolean = true
  cartId: any
  cartShopping$: Observable<any> = this.activeCartService.getActiveCartId()
  displayContentsOnLoad: boolean = false
  displaySearchLoader: boolean = false
  getMonths$: Observable<any>
  monthDifference: number = 6
  public toMinDate
  public fromMaxDate
  public fromMax
  public fromStartDate
  currency: any

  @ViewChild('categoryOne', { read: ElementRef }) categoryOne: ElementRef
  @ViewChild('categoryTwo', { read: ElementRef }) categoryTwo: ElementRef
  @ViewChild('categoryThree', { read: ElementRef }) categoryThree: ElementRef
  @ViewChild('categoryFour', { read: ElementRef }) categoryFour: ElementRef
  @ViewChild('defaultOpen', { read: ElementRef }) defaultOpen: ElementRef
  accessibility = ACCESSIBILITY
  dateObject: any

  constructor(
    protected globalMessageService: GlobalMessageService,
    private breadCrumbService: BreadcrumbService,
    private orderTrackingService: OrderTrackingService,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private router: Router,
    private formBuilder: FormBuilder,
    protected activeCartService: ActiveCartFacade,
    private multiCartService: MultiCartFacade,
    private commonService: CommonService,
    private userRoleService: UserRoleService,
    private translate: TranslationService,
    public datepipe: DatePipe
  ) {}

  openTab(evt, prodName, elementReference: ElementRef) {
    let i, tabcontent, tablinks
    // tabcontent = document.getElementsByClassName('tabcontent');
    tabcontent = this.elRef.nativeElement.querySelectorAll('.tabcontent')
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }
    // tablinks = document.getElementsByClassName('tablinks');
    tablinks = this.elRef.nativeElement.querySelectorAll('.tablinks')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '')
    }
    // document.getElementById(prodName).style.display = 'block';
    this.renderer.setStyle(elementReference, 'display', 'block')
    evt.currentTarget.className += ' active'

    this.resetInquiryForm()
  }

  ngOnInit(): void {
    this.currency = sessionStorage.getItem('currency')
    this.fetchOrderId()
    this.getCartId()

    this.translate
      .translate('orderTracking.myOrders')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadCrumbs([
          {
            label: res,
            link: '/order-history',
          },
        ])
      )

    this.translate
      .translate('orderTracking.orderHeader')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res + this.orderIdToBeTracked)
      )

    this.fetchOrderTrackingDetails()

    this.inquiryForm = this.formBuilder.group({
      orderInquiry: new FormControl('', Validators.required),
      inquiryDesc: new FormControl('', Validators.required),
    })
    this.fetchInquiryTypes()
  }

  get f() {
    return this.inquiryForm.controls
  }

  ngAfterViewInit() {
    //document.getElementById('defaultOpen').click();
    if (this.defaultOpen !== undefined) {
      this.defaultOpen.nativeElement.click()
    }
  }

  fetchOrderId() {
    this.activatedRoute.paramMap.subscribe((value: any) => {
      this.orderIdToBeTracked = value.params.orderid
    })
    this.activatedRoute.queryParams.subscribe((params) => {
      this.dateObject = params
    })
  }

  fetchOrderTrackingDetails() {
    this.orderTrackingService
      .getOrderTrackingDetails(
        this.orderIdToBeTracked,
        this.dateObject.fromDate,
        this.dateObject.toDate
      )
      .subscribe(
        (data) => {
          this.fullResponse = data
          this.orderTrackingResponse = data['lineData']
          this.displayContentsOnLoad = true
        },
        (error) => {
          this.displayContentsOnLoad = false
          this.globalMessageService.add(
            { key: 'orderTracking.issueWhileFetchingOrderDetails' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  fetchOrderStatus(statusResponse) {
    let status = ''
    if (statusResponse !== undefined && statusResponse !== null) {
      const statusObj = statusResponse.toUpperCase()
      switch (statusObj) {
        // case SAP_ORDER_STATUS.ORDER_SUBMITTED:
        //   status = OrderStatusTypes.SUBMITTED.statusName;
        //   break;
        case SAP_ORDER_STATUS.ORDER_IN_PROGRESS:
          status = OrderStatusTypes.PROGRESS.statusName
          break
        case SAP_ORDER_STATUS.SHIPPED:
          status = OrderStatusTypes.SHIPPED.statusName
          break
        case SAP_ORDER_STATUS.SHIPPED_INVOICED:
          status = OrderStatusTypes.INVOICED.statusName
          break
        case SAP_ORDER_STATUS.BLOCKED:
          status = OrderStatusTypes.BLOCKED.statusName
          break
      }
    }

    return status
  }

  fetchOrderStatusColor(statusResponse) {
    let color = ''
    if (statusResponse !== undefined && statusResponse !== null) {
      const statusObj = statusResponse.toUpperCase()
      switch (statusObj) {
        // case SAP_ORDER_STATUS.ORDER_SUBMITTED:
        //   color = '#506C65';
        //   break;
        case SAP_ORDER_STATUS.ORDER_IN_PROGRESS:
          color = '#CB6E17'
          break
        case SAP_ORDER_STATUS.SHIPPED:
          color = '#044E54'
          break
        case SAP_ORDER_STATUS.SHIPPED_INVOICED:
          color = '#506C65'
          break
        case SAP_ORDER_STATUS.BLOCKED:
          color = '#E12D39'
          break
      }
    }
    return color
  }

  checkWhetherBlocked(statusResponse) {
    return statusResponse !== null &&
      statusResponse !== undefined &&
      statusResponse.toUpperCase() === SAP_ORDER_STATUS.BLOCKED
      ? true
      : false
  }

  setBubbleOrderStatus() {
    return StatusType.ORDER
  }

  setBubbleOrderStatusId(statusResponse) {
    let statusId: number
    if (statusResponse !== undefined && statusResponse !== null) {
      let statusObj = statusResponse.toUpperCase()
      switch (statusObj) {
        // case SAP_ORDER_STATUS.ORDER_SUBMITTED:
        //   statusId = OrderStatusIndex.SUBMITTED;
        //   break;
        case SAP_ORDER_STATUS.ORDER_IN_PROGRESS:
          statusId = OrderStatusIndex.PROGRESS
          break
        case SAP_ORDER_STATUS.SHIPPED:
          statusId = OrderStatusIndex.SHIPPED
          break
        case SAP_ORDER_STATUS.SHIPPED_INVOICED:
          statusId = OrderStatusIndex.INVOICED
          break
        case SAP_ORDER_STATUS.BLOCKED:
          statusId = OrderStatusIndex.BLOCKED
          break
      }
    }
    return statusId
  }

  getCartId() {
    this.cartShopping$ = this.activeCartService.getActiveCartId()
    this.cartShopping$.subscribe((data) => {
      this.cartId = data
    })
  }

  repeatThisOrder() {
    this.displaySearchLoader = true
    this.orderTrackingService
      .repeatOrder(this.orderIdToBeTracked, this.cartId)
      .subscribe(
        (data) => {
          if (data !== undefined) {
            this.activeCartService.getActiveCartId().subscribe((res) => {
              this.multiCartService.loadCart({
                userId: 'current',
                cartId: res,
                extraData: {
                  active: true,
                },
              })
              this.displaySearchLoader = false
            })

            if (
              data['nonCatalogProductList'] !== undefined &&
              data['nonCatalogProductList'].length > 0
            ) {
              this.displaySearchLoader = false
              this.globalMessageService.add(
                data['nonCatalogProductList'][0],
                GlobalMessageType.MSG_TYPE_ERROR,
                9000
              )
            }
            this.router.navigate(['/cart'])
          }
        },
        (error) => {
          this.displaySearchLoader = false
          this.globalMessageService.add(
            { key: 'orderTracking.issueWhileRepeatingOrder' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  fetchInquiryTypes() {
    this.orderTrackingService.getInquiryTypes().subscribe((response) => {
      if (response != undefined && response != null) {
        this.orderInquiries = response['inquiryTypeValues']
      }
    })
  }

  submitInquiry(customerPO, poDate) {
    this.inquiryFormSubmitted = true
    if (this.inquiryForm.valid) {
      this.orderTrackingService
        .submitInquiryToCSR(
          this.inquiryForm.value.orderInquiry,
          this.inquiryForm.value.inquiryDesc,
          this.orderIdToBeTracked,
          customerPO,
          poDate
        )
        .subscribe(
          (response) => {
            this.displayFormHideMessage = false
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'orderTracking.issueWhilePostingQuery' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  getBlockText(blockText) {
    if (blockText) {
      let blockTextArr = blockText.split(',')
      return blockTextArr
    }
    return ''
  }

  resetInquiryForm() {
    this.inquiryFormSubmitted = false
    this.inquiryForm.reset()
    this.displayFormHideMessage = true
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }
  downloadPDF() {
    this.orderTrackingService
      .downloadOrderDetails(this.fullResponse, this.orderIdToBeTracked)
      .subscribe(
        (res: any) => {
          let fileName = 'OrderDetail_' + this.orderIdToBeTracked
          saveAs(res, fileName)
        },
        (error) => {
          // this.displayDownloadError;
        }
      )
  }
  getNetPrice(netPrice, jpyCurrency) {
    if (jpyCurrency.indexOf('JPY') != -1) {
      netPrice = netPrice.split('.')
      return netPrice[0]
    } else {
      return parseFloat(netPrice.replace(/,/g, '')).toFixed(2)
    }
  }
}
